

















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableList } from '@/shims-global'
import MainTitle from '../_components/MainTitle.vue'
import SubTitle from '../_components/SubTitle.vue'
import Page5Chart1 from '../_components/charts/Page5Chart1.vue'
import Page3Chart2 from '../_components/charts/Page3Chart2.vue'
@Component({
  components: {
    MainTitle,
    SubTitle,
    Page5Chart1,
    Page3Chart2
  }
})
export default class extends Vue {
  @Prop({}) private data!: any
  private list: Array < object > = [];
  private itemList: any = [{
    name: '很矮 得分＜10',
    color: '#F87A52'
  }, {
    name: '较矮 10≤得分≤25',
    color: '#FFA100'
  }, {
    name: '一般 25<得分≤75',
    color: '#6DD400'
  },
  {
    name: '较高 75<得分≤90',
    color: '#3A91FF'
  }, {
    name: '很高 得分>90',
    color: '#A35DFF'
  }
  ]
  private colorList: any = []
  created() {
    this.itemList.map((v:any) => {
      this.colorList.push(v.color)
    })
    let obj: any = this.data.pie
    obj.HeightLastTypeIntro = obj.title
    obj.data = []
    this.data.pie.dataList.map((v:any) => {
      obj.data.push({ name: v.name, value: v.value * 100 })
    })
    this.list.push(obj)
    this.data.staminaHeightPercentVoLine.map((v:any) => {
      this.list.push(v)
    })
  }
}
